import api from 'api/apiInstance';

export function practiceAdminAssignApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
